import React from 'react';
import Reflux from 'reflux';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from 'Components';
import {Button, DatePicker, Icon, Modal, Upload} from "antd";
import {openNotice, config, APIS} from 'Utils';
import {
    getHistoryList,
    getRequestShipHistory,
    stockScreening,
    getBatchPrint,
    uploadFile, getEscrowCustlist
} from '../../service/shipRequest';
import moment from "moment/moment";
import {getDealerList} from "../../service/dealer";

class ShipRequestHistory extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            options: [],
            rows: [],
            stockType: [],
            total: 0,
            loading: false,
            btnLoading: false,
            visible: false,
            visible1: false,
            uploadVisible: false,
            selectedRowKeysOutside: [],
            fileName: '',
            signDate: '',
            informationLi: [],
            escrowCustlist: [],
            printBatchId: '',
            searchObj: {
                itemNum: '',
                itemDesc: '',
                orderNumber: '',
                organizationId: '',
                deliveryId: '',
                closeHomologous: '',
                printBatchId: '',
                receiptCustId: '',
                isUpload: '',
                bookedDateFrom: moment().add(-1, 'y').format('YYYY-MM-DD'),
                bookedDateTo: moment().format('YYYY-MM-DD'),
                p: 1,
                s: 10
            },
            searchDetailObj: {
                p: 1,
                s: 10,
                batchId: '',
                deliveryId: ''
            },
            detailRow: [],
            detailTotal: 0,
            detailLoading: false,
            userData: JSON.parse(window.localStorage.getItem('login_user_information') || '{}') || ''
        };
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
        this.pageChange = this.pageChange.bind(this);
        this.detailPageChange = this.detailPageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.detailOk = this.detailOk.bind(this);
        this.detailCancel = this.detailCancel.bind(this);

    };

    routeLeaveHook(nextLocation) {
    };

    componentDidMount() {
        stockScreening().then(res => {
            let arr = [];
            res.data.forEach(x => {
                arr.push({
                    text: x.delvName,
                    value: x.id
                })
            });
            this.setState({stockType: arr})
        });

        getDealerList({s: 1000, p: 1,}).then(res => {
            if (res.code === 200 && res.data.length > 0) {
                var linkAddress = res.data[0].address + " " + res.data[0].linkman + " " + res.data[0].telephone;
                this.setState({linkAddress: linkAddress})
            }
        });
        getEscrowCustlist().then(res => {
            let arr = [];
            res.data.forEach(x => {
                arr.push({
                    text: x.name + "_" + x.address + "_" + x.seller + "_" + x.phone,
                    value: x.id
                })
            });
            this.setState({escrowCustlist: arr})
        })
        this.getData();
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    };

    goView(url) {
        hashHistory.push(url);
    };

    getData() {
        const self = this;
        self.setState({loading: true});
        const {searchObj} = this.state;
        searchObj.orderField = "created_date desc";
        getHistoryList(searchObj).then(res => {
            if (res.status) {
                self.setState({total: res.total, rows: res.data, loading: false});
            } else {
                console.error(res.message);
                this.setState({loading: false})
            }
        });
    };

    getDetail(record) {
        const self = this;
        self.setState({detailLoading: true});
        var searchDetailObj = self.state.searchDetailObj;
        searchDetailObj.batchId = record.batchId;
        searchDetailObj.deliveryId = record.deliveryId;
        getRequestShipHistory(searchDetailObj).then(res => {
            if (res.status) {
                self.setState({detailTotal: res.total, detailRows: res.data, detailLoading: false});
            } else {
                openNotice('error', '获取历史数据失败！');
            }
        })
    }

    onOutsideSelectChange = (selectedRowKeys, selectedRows) => {
        this.setState({selectedRowKeysOutside: selectedRowKeys});
    };

    pageChange(page, pageSize) {
        const self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}, loading: true}, function () {
            self.getData();
        });
    }

    detailPageChange(page, pageSize) {
        const self = this;
        this.setState({
            searchDetailObj: {...this.state.searchDetailObj, s: pageSize, p: page},
            detailLoading: true
        }, function () {
            self.getDetail(self.state.record);
        });
    }

    advanceReset() {
        const self = this;
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                itemNum: '',
                itemDesc: '',
                orderNumber: '',
                deliveryId: '',
                organizationId: '',
                closeHomologous: '',
                printBatchId: '',
                receiptCustId: '',
                isUpload: '',
                bookedDateFrom: moment().add(-1, 'y').format('YYYY-MM-DD'),
                bookedDateTo: moment().format('YYYY-MM-DD'),
                p: 1,
                s: 10
            }
        }, () => {
            self.getData();
        })
    };

    advanceSubmit(form) {
        const self = this;
        this.setState({searchObj: {...this.state.searchObj, p: 1}, loading: true}, function () {
            self.getData();
        });
    };


    openDetail = (record, index, value) => {
        this.setState({visible: true, record: record});
        this.getDetail(record);
    }

    openReport = (record, index, value) => {
        const self = this;
        var searchDetailObj = self.state.searchDetailObj;
        searchDetailObj.batchId = record.batchId;
        searchDetailObj.deliveryId = record.deliveryId;
        searchDetailObj.s = 9999;
        getRequestShipHistory(searchDetailObj).then(res => {
            if (res.status) {
                self.setState({detailTotal: res.total, detailRows: res.data}, () => {
                    window.sessionStorage.setItem('shipRequest', JSON.stringify(res.data));
                    window.open(`/pcweb/#/shipRequestPrint`);
                });
            } else {
                openNotice('error', '获取历史数据失败！');
            }
        })
    }

    deleteInformation(index) {
        const {informationLi} = this.state;
        informationLi.splice(index, 1);
        this.setState({
            informationLi: informationLi
        });
    };

    signDateOnChange(date, dateString) {
        this.setState({
            signDate: date ? date.valueOf() : null
        });
    }

    getBatchReport = (record, index, value) => {
        var param = {"printBatchId": record.printBatchId};
        getBatchPrint(param).then(res => {
            if (res.status) {
                window.sessionStorage.setItem('shipRequestBatch', JSON.stringify(res.data));
                window.sessionStorage.setItem('shipRequestBatchAddress', this.state.linkAddress);
                window.open(`/pcweb/#/shipRequestPrintBatch`);
            } else {
                openNotice('error', '获取历史数据失败！');
            }
        })
    }

    getBatchSummaryReport = (record, index, value) => {
        var param = {"printBatchId": record.printBatchId};
        getBatchPrint(param).then(res => {
            if (res.status) {
                window.sessionStorage.setItem('shipRequestBatchSummary', JSON.stringify(res.data));
                window.sessionStorage.setItem('shipRequestBatchAddress', this.state.linkAddress);
                window.open(`/pcweb/#/shipRequestPrintBatchSummary`);
            } else {
                openNotice('error', '获取历史数据失败！');
            }
        })
    }

    openUploadFile = (record, index, value) => {

        this.setState({
            informationLi: record.filePath ? [
                {
                    uid: -2,
                    name: record.fileName,
                    status: 'done',
                    id: record.fileId,
                    url: `${config.server}${record.filePath.replace("getFile", "getFileDown")}`,
                }
            ] : [], signDate: record.signDate, printBatchId: record.printBatchId
        }, () => {
            this.setState({uploadVisible: true})
        });

    }

    batchReport = () => {
        const self = this;
        let isTrue = true;

        if (self.state.selectedRowKeysOutside == '') {
            openNotice('warning', '请勾选行再次提交');
            return;
        }

        var selectedRowKeys = self.state.selectedRowKeysOutside;
        var rows = self.state.rows.filter(x => selectedRowKeys.includes(x.batchId));

        rows.forEach(item => {
            if (item.printBatchId != null) {
                isTrue = false;
            }
        })

        if (isTrue) {
            self.setState({btnLoading: true});
            var param = {"tgShipRequestLinesList": rows};
            getBatchPrint(param).then(res => {
                if (res.status) {
                    self.setState({btnLoading: false, selectedRowKeysOutside: []}, () => {
                        self.getData();
                    });
                    window.sessionStorage.setItem('shipRequestBatch', JSON.stringify(res.data));
                    window.open(`/pcweb/#/shipRequestPrintBatch`);
                } else {
                    openNotice('error', '获取历史数据失败！');
                    self.setState({btnLoading: false});
                }
            })
        } else {
            self.setState({visible1: true});
        }
    }

    handleOk = () => {
        const self = this;
        var selectedRowKeys = self.state.selectedRowKeysOutside;
        var rows = self.state.rows.filter(x => selectedRowKeys.includes(x.batchId));
        self.setState({btnLoading: true});
        var param = {"tgShipRequestLinesList": rows};
        getBatchPrint(param).then(res => {
            if (res.status) {
                self.setState({btnLoading: false, selectedRowKeysOutside: [], visible1: false}, () => {
                    self.getData();
                });
                window.sessionStorage.setItem('shipRequestBatch', JSON.stringify(res.data));
                window.open(`/pcweb/#/shipRequestPrintBatch`);
            } else {
                openNotice('error', '获取历史数据失败！');
                self.setState({btnLoading: false, visible1: false});
            }
        })
    }

    uploadFileHandleOk = () => {
        if (this.state.informationLi.length == 0 || this.state.signDate == null) {
            openNotice('warning', '请填写签回日期，并上传附件！');
        } else {
            var param = {
                "printBatchId": this.state.printBatchId,
                "signDate": this.state.signDate,
                "fileId": this.state.informationLi.length > 0 ? this.state.informationLi[0].id : ''
            };
            uploadFile(param).then(res => {
                if (res.status) {
                    openNotice('success', '上传成功');
                    this.setState({uploadVisible: false}, () => {
                        this.getData();
                    });
                } else {
                    openNotice('error', '上传失败，请稍后重试！');
                }
            })
        }
    }

    handleCancel = () => {
        this.setState({visible1: false});
    }

    uploadFileHandleCancel = () => {
        this.setState({uploadVisible: false});
    }

    setFilterParam(name, value) {
        if (name === 'orderTime') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    bookedDateFrom: value.from,
                    bookedDateTo: value.end
                }
            })
        } else {
            this.setState({searchObj: {...this.state.searchObj, [name]: value}})
        }
    };

    detailOk = () => {
        this.setState({visible: false});
    }

    detailCancel = () => {
        this.setState({visible: false});
    }

    render() {
        const {
            rows,
            total,
            loading,
            searchObj,
            visible,
            visible1,
            uploadVisible,
            detailLoading,
            detailTotal,
            searchDetailObj,
            detailRows,
            stockType,
            selectedRowKeysOutside,
            btnLoading,
            informationLi,
            signDate,
            escrowCustlist
        } = this.state;
        var self = this;
        const advanceProps = {
            fileds: [
                {
                    name: 'printBatchId',
                    label: '打印批次',
                    text: '输入打印批次',
                    defaultValue: searchObj.printBatchId,
                    type: 'default'
                },
                {
                    name: 'itemNum',
                    label: '物料编码',
                    text: '输入物料编码',
                    defaultValue: searchObj.itemNum,
                    type: 'default'
                },
                {
                    name: 'itemDesc',
                    label: '物料名称',
                    text: '输入物料名称',
                    defaultValue: searchObj.itemDesc,
                    type: 'default'
                }, {
                    name: 'orderNumber',
                    label: '订单编号',
                    text: '输入订单编号',
                    defaultValue: searchObj.orderNumber,
                    type: 'default'
                }, {
                    name: 'deliveryId',
                    label: '出库单号',
                    text: '输入出库单号',
                    defaultValue: searchObj.deliveryId,
                    type: 'default'
                }, {
                    name: 'closeHomologous',
                    label: '结算对应号',
                    text: '输入结算对应号',
                    defaultValue: searchObj.closeHomologous,
                    type: 'default'
                }, {
                    name: 'orderTime',
                    label: '请求日期',
                    options: [
                        {text: '开始时间'},
                        {text: '结束时间'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.startBookDate || '',
                        end: searchObj.endBookDate || ''
                    },
                }, {
                    name: 'organizationId',
                    label: '提货组织',
                    text: '选择提货组织',
                    defaultValue: searchObj.organizationId,
                    type: 'select',
                    multiple: false,//支持多选
                    options: stockType
                }, {
                    name: 'receiptCustId',
                    label: '送货地址',
                    text: '选择送货地址',
                    defaultValue: searchObj.receiptCustId,
                    type: 'select',
                    multiple: false,//支持多选
                    options: escrowCustlist,
                    allowClear: true
                }, {
                    name: 'isUpload',
                    label: '是否上传',
                    text: '是否上传',
                    options: [
                        {value: '', text: '全部'},
                        {value: '1', text: '是'},
                        {value: '0', text: '否'}
                    ],
                    multiple: false,//支持多选
                    type: 'select',
                    defaultValue: searchObj.isUpload,
                }
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };


        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'batchId',
            pageParam: {
                total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '打印批次',
                    dataIndex: 'printBatchId'
                }, {
                    title: '请求时间',
                    dataIndex: 'createdDate',
                    render: text => <span>{text ? moment(text).format('YYYY-MM-DD HH:mm:ss') : ''}</span>
                }, {
                    title: '托管单位',
                    dataIndex: 'salesUnitName'
                }, {
                    title: '提货组织',
                    dataIndex: 'organizationName'
                }, {
                    title: '出库单号',
                    dataIndex: 'deliveryId'
                }, {
                    title: '送货地址',
                    dataIndex: 'receiptCust'
                }, {
                    title: '处理日期',
                    dataIndex: 'transactionDate',
                    render: text => <span>{text ? moment(text).format('YYYY-MM-DD HH:mm:ss') : ''}</span>
                }, {
                    title: '处理结果',
                    dataIndex: 'transactionMessage'
                },
                {
                    title: '签回时间',
                    dataIndex: 'signDate',
                    render: text => <span>{text ? moment(text).format('YYYY-MM-DD HH:mm:ss') : ''}</span>
                },
                {
                    title: '附件名称',
                    dataIndex: 'fileName',
                    render: (text, record, index) => {
                        if (text) {
                            return (
                                <a href={config.server + record.filePath.replace("getFile", "getFileDown")}>{text}</a>)
                        }
                    }
                },
                {
                    title: '操作',
                    dataIndex: 'active',
                    width: 280,
                    render: (text, record, index) => {
                        if (record.printBatchId) {
                            return (<div><Button style={{display: 'inline-block', marginRight: '10px'}} size={'small'}
                                                 onClick={this.openDetail.bind(this, record, index)}>详细</Button>
                                {/*<Button style={{display: 'inline-block', marginRight: '10px'}} type="primary"*/}
                                {/*        size={'small'}*/}
                                {/*        onClick={this.openReport.bind(this, record, index)}>打印</Button>*/}
                                <Button style={{display: 'inline-block', marginRight: '10px'}} type="primary"
                                        size={'small'}
                                        onClick={this.getBatchReport.bind(this, record, index)}>单据</Button>
                                <Button style={{display: 'inline-block', marginRight: '10px'}} type="primary"
                                        size={'small'}
                                        onClick={this.getBatchSummaryReport.bind(this, record, index)}>汇总单据</Button>
                                <Button style={{display: 'inline-block', marginRight: '10px'}} type="primary"
                                        size={'small'}
                                        onClick={this.openUploadFile.bind(this, record, index)}>上传</Button>
                            </div>)
                        } else {
                            return (<div><Button style={{display: 'inline-block', marginRight: '10px'}} size={'small'}
                                                 onClick={this.openDetail.bind(this, record, index)}>详细</Button>
                            </div>)
                        }

                    },
                },
            ],
            rows,
            rowSelection: {
                selectedRowKeys: selectedRowKeysOutside,
                onChange: this.onOutsideSelectChange,
                getCheckboxProps: record => ({
                    disabled: record.deliveryId == ''
                })
            },
        };

        const detailProps = {
            rowKey: 'id',
            loading: detailLoading,
            pageParam: {
                total: detailTotal,
                current: searchDetailObj.p,//当前页码
                pageSize: searchDetailObj.s,//当前分页数
                onChange: this.detailPageChange,
            },
            columns: [
                {
                    title: '订单编号',
                    dataIndex: 'orderNumber'
                }, {
                    title: '结算对应号',
                    dataIndex: 'closeHomologous'
                }, {
                    title: '行号',
                    dataIndex: 'lineNumber'
                }, {
                    title: '物料编码',
                    dataIndex: 'itemNum',
                }, {
                    title: '物料描述',
                    dataIndex: 'itemDesc',
                }, {
                    title: '未发数量',
                    dataIndex: 'quantityUnShip'
                }, {
                    title: '请求数量',
                    dataIndex: 'quantity'
                }
            ],
            rows: detailRows,
        };


        let informationHtml = (informationLi || []).map(function (ele, key) {
            return <div className="edit_upload_information" key={key}>
                <span>{ele.fileName}</span>
                <i className="anticon anticon-delete" onClick={self.deleteInformation.bind(self, key)}></i>
            </div>
        });

        const informationProps = {
            fileList: [...informationLi],
            className: 'upload-img-only',
            listType: 'file',
            action: APIS.upload,
            onChange: (info) => {
                console.log(info);
                let fileList = info.fileList;
                fileList = fileList.slice(-1); //控制上传数量
                fileList = fileList.map((file) => {
                    if (file.response) {//上传成功后提取文件id 和 URL
                        file.url = `${config.server}${file.response.data.filePath.replace("getFile", "getFileDown")}`;
                        file.id = file.response.data.id;
                    }
                    return file;
                });
                fileList = fileList.filter((file) => {
                    if (file.response) {
                        return file.response.status; //当上传接口返回成功时才更新fileList
                    }
                    return true;
                });
                this.setState({informationLi: fileList});
            }

        };


        return <div className="dms-body">
            <DmsTab options={[`托管发货历史查询`]} defaultKey={0}></DmsTab>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew {...advanceProps}/>
                </div>
            </div>
            <div className="dms-table-box">
                <div style={{marginBottom: 8}}>
                    <Button type="primary" style={{marginRight: 8}}
                            onClick={this.batchReport.bind(this)} loading={btnLoading}>合并打印</Button>
                </div>
                <TableView {...tableViewProps}/>
            </div>

            <Modal
                visible={visible}
                title='批次详情'
                onOk={this.detailOk}
                onCancel={this.detailCancel}
                maskClosable={false}
                width={1200}
                style={{top: 20}}
            >
                <TableView {...detailProps} bordered style={{marginTop: 10}}/>
            </Modal>

            <Modal
                title="确认"
                visible={visible1}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
            >
                <p>存在已经打印过的数据，<span
                    style={{color: 'red'}}>重新打印会更新打印批次（打印批次用于签回上传附件使用），</span>确认重新打印吗?
                </p>
            </Modal>

            <Modal
                title="上传附件"
                visible={uploadVisible}
                onOk={this.uploadFileHandleOk}
                onCancel={this.uploadFileHandleCancel}
            >
                <p><label>打印批次：{this.state.printBatchId}</label>
                </p>
                <p><label>签收日期：</label>
                    <DatePicker onChange={this.signDateOnChange.bind(this)}
                                value={signDate ? moment(parseInt(signDate)) : null}
                                format={'YYYY-MM-DD HH:mm:ss'}/>
                </p>
                <p>
                    <Upload {...informationProps}>
                        <div style={{padding: '12px', background: '#fff'}}>
                            <Button><Icon type="upload"/> 上传附件</Button>
                        </div>
                    </Upload>
                </p>
            </Modal>

        </div>
    }
}

export default withRouter(ShipRequestHistory);


// WEBPACK FOOTER //
// ./src/routes/shipRequest/shipRequestHistory.js